import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './pr-arrow-submit.scss';
import browser from 'browser-detect';
import Loading from '../pr-loading';

function ArrowSubmitComponent({
  selectedAnsweresCount,
  neededSelectedCount,
  onClick,
  isLoading,
  questionsStep,
  type,
  ref,
  allowOnEnterKey,
}) {
  const arrowEl = useRef(null);
  const arrowWrapper = useRef(ref);
  const browserInfo = browser();
  const [onEnterKey, setOnEnterKey] = useState(allowOnEnterKey);

  const reset = () => {
    arrowEl.current.style.transform = 'translate(0px,0px) scale(1)';
  };

  const onMouseEnter = (e) => {
    if (
      e.target.closest('.large') !== null &&
      e.target.closest('.disable') === null
    ) {
      let x = e.clientX - arrowWrapper.current.getBoundingClientRect().left;
      let y = e.clientY - arrowWrapper.current.getBoundingClientRect().top;
      if (x < -1 || y < -1) {
        reset();
      } else {
        x -= arrowWrapper.current.getBoundingClientRect().width / 2;
        y -= arrowWrapper.current.getBoundingClientRect().height / 2;
        arrowEl.current.style.transform = `translate(${x}px,${y}px) scale(1.15)`;
      }
    }
  };

  const onMouseLeave = (e) => {
    if (
      typeof e.target.className === 'string' &&
      e.target.className.includes('hover-area') &&
      e.target.className.includes('large') &&
      !e.target.className.includes('disable')
    ) {
      reset();
    }
  };

  const allowToSubmitWithEnter = (e) => {
    const allow = arrowWrapper.current.getAttribute('data-key') === 'true';
    if (allow && e.keyCode === 13) {
      onClick();
    }
  };

  useEffect(() => {
    if (type.indexOf('large') > -1 && browserInfo.name !== 'firefox') {
      document.addEventListener('keydown', allowToSubmitWithEnter);
      arrowWrapper.current.addEventListener('mousemove', onMouseEnter);
      arrowWrapper.current.addEventListener('mouseleave', onMouseLeave);
    }
    return () => {
      document.removeEventListener('keydown', allowToSubmitWithEnter);
      if (arrowWrapper && arrowWrapper.current) {
        arrowWrapper.current.removeEventListener('mousemove', onMouseEnter);
        arrowWrapper.current.removeEventListener('mouseleave', onMouseLeave);
      }
    };
  }, []);

  useEffect(() => {
    setOnEnterKey(allowOnEnterKey);
  }, [allowOnEnterKey]);

  const isAccessToAnswering = () => {
    if (selectedAnsweresCount === neededSelectedCount) {
      return '';
    }
    return ' disable';
  };

  const selectorChanger = () => {
    let selector = type;
    if (type.indexOf('left') !== -1) {
      if (questionsStep > 1) {
        selector += '';
      } else {
        selector += ' disable';
      }
    } else {
      selector += isAccessToAnswering();
      selector += ' with-counter';
    }
    return selector;
  };

  return (
    <div
      ref={arrowWrapper}
      data-key={onEnterKey}
      className={`hover-area ${selectorChanger()}`}
      needed-count={neededSelectedCount}
      selected-count={selectedAnsweresCount}
      onClick={() => {
        reset();
        onClick();
      }}
    >
      <div className="arrow-submit-wrapper" ref={arrowEl}>
        {!isLoading && (
          <svg
            className="submit-svg"
            width="240"
            height="240"
            viewBox="0 0 240 240"
          >
            <circle id="static" cx="120" cy="120" r="115" />
            <circle id="animated" cx="120" cy="120" r="115" />
          </svg>
        )}
        {!isLoading && (
          <span className="counter">
            {selectedAnsweresCount}
            <span> / </span>
            {neededSelectedCount}
          </span>
        )}
        {!isLoading && <span className="arrow" />}
        {isLoading && <Loading color="#fff" className="loading" />}
      </div>
    </div>
  );
}

ArrowSubmitComponent.propTypes = {
  selectedAnsweresCount: PropTypes.number,
  neededSelectedCount: PropTypes.bool,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  questionsStep: PropTypes.number,
  type: PropTypes.string,
  ref: PropTypes.element,
  allowOnEnterKey: PropTypes.bool,
};

ArrowSubmitComponent.defaultProps = {
  selectedAnsweresCount: undefined,
  neededSelectedCount: undefined,
  onClick: undefined,
  isLoading: false,
  questionsStep: 0,
  type: 'relative large',
  ref: null,
  allowOnEnterKey: false,
};

export default ArrowSubmitComponent;
